<script setup lang="ts">
import { NCard } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  title?: string
  size?: 'small' | 'medium' | 'large' | 'huge'
  bordered?: boolean
  closable?: boolean
  hoverable?: boolean
  embedded?: boolean
  segmented?: boolean | { content?: boolean; footer?: boolean; action?: boolean }
  loading?: boolean
  headerStyle?: any
  headerClass?: string
  contentStyle?: any
  contentClass?: string
  footerStyle?: any
  footerClass?: string
  actionStyle?: any
  actionClass?: string
  onClose?: () => void
}>(), {
  title: undefined,
  size: 'medium',
  bordered: true,
  closable: false,
  hoverable: false,
  embedded: false,
  segmented: false,
  loading: false,
  headerStyle: undefined,
  headerClass: undefined,
  contentStyle: undefined,
  contentClass: undefined,
  footerStyle: undefined,
  footerClass: undefined,
  actionStyle: undefined,
  actionClass: undefined,
})

const emit = defineEmits<{
  'close': []
}>()

const attrs = useAttrs()

const onClose = () => {
  emit('close')
}
</script>

<template>
  <NCard
    :title="title"
    :size="size"
    :bordered="bordered"
    :closable="closable"
    :hoverable="hoverable"
    :embedded="embedded"
    :segmented="segmented"
    :loading="loading"
    :header-style="headerStyle"
    :header-class="headerClass"
    :content-style="contentStyle"
    :content-class="contentClass"
    :footer-style="footerStyle"
    :footer-class="footerClass"
    :action-style="actionStyle"
    :action-class="actionClass"
    v-bind="attrs"
    @close="onClose"
  >
    <template #header>
      <slot name="header" />
    </template>
    <template #header-extra>
      <slot name="header-extra" />
    </template>
    <template #default>
      <slot />
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
    <template #action>
      <slot name="action" />
    </template>
    <template #cover>
      <slot name="cover" />
    </template>
  </NCard>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
